import makeStyles from 'e100-react-components/lib/styles/makeStyles';

import { Padding } from './ListItemIcon';

interface StyleProps {
  padding?: Padding;
}

export const useStyles = makeStyles(({ spacing, typography }) => ({
  container: ({ padding = {} }: StyleProps) => ({
    paddingLeft: spacing(padding.left ?? 2),
    paddingRight: spacing(padding.right ?? 2),
    paddingTop: spacing(padding.top ?? 0),
    paddingBottom: spacing(padding.bottom ?? 0),
    minHeight: spacing(6.5)
  }),
  icon: {
    display: 'block'
  },
  iconContainer: {
    width: spacing(5)
  },
  checkboxContainer: {
    width: '100%'
  },
  titleRoot: {
    fontWeight: typography.subtitle1.fontWeight
  }
}));
